import axios from 'axios';

export interface ForecastSolarEstimate {
  plant: {
    id: number;
    name: string;
    lat: number;
    lon: number;
    peakpower: number;
    dec: number;
    az: number;
  };
  forecast: {
    result: {
      watts: Record<string, number>;
      watt_hours: Record<string, number>;
      watt_hours_day: Record<string, number>;
    };
    message: {
      type: string;
      text: string;
      info: {
        latitude: number;
        longitude: number;
        distance: number;
        place: string;
        timezone: string;
        time: string;
      };
      ratelimit: {
        period: number;
        limit: number;
        remaining: number;
      };
    };
  };
}

export const fetchForecastSolarEstimate = async (uuid: string): Promise<ForecastSolarEstimate> => {
  const response = await axios.get(`/api/powerplants/${uuid}/forecast-solar`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });
  return response.data;
};
